export default __webpack_public_path__ + "static/media/CR3.53265787.png";